var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThunderstormAndHail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 28L11.0001 19C11.0001 19 10.0176 16.8959 10.0176 14C10.0176 7.37258 15.8786 2 23.1085 2C27.954 2 32.1846 4.41319 34.4481 8H37.0176C41.9881 8 46.0176 12.0294 46.0176 17C46.0176 20.128 44 24 42 26.4962C40 28.9924 28 43 28 43",
    stroke: "#6E7191",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.607 17.4453L13.3224 31.702L23.3075 32.2481L12 45.0001",
    stroke: "#EAAC30",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0698 22.5L32.4498 23.1193M5.5 39.756L4.89453 40.3615",
    stroke: "#6E7191",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThunderstormAndHail);
export default __webpack_public_path__ + "static/media/thunderstorm-and-hail.d763c65c205c28b7c7830fea132f6867.svg";
export { ForwardRef as ReactComponent };